import { CheckboxActiveIcon } from 'app/components/Icons';
import CheckboxIcon from 'app/components/Icons/CheckboxIcon';
import Pill from 'app/components/Pill';
import React from 'react';
import { ITag } from '../../containers/Boards/types';

interface MenuItemsProps {
    option: ITag;
    handleCheckboxChange: (option) => void;
    selectedTags: string[]
}

const MenuItems: React.FC<MenuItemsProps> = ({ handleCheckboxChange, option, selectedTags }) => {
    return (
        <>
            <div
                key={option.title}
                className="flex flex-row items-center  py-1 w-full gap-2"
                onClick={(e) => {
                    e.preventDefault();
                    handleCheckboxChange(option);
                }}
            >
                {selectedTags?.includes(option?._id) ? (
                    <CheckboxActiveIcon size={20}/>
                ) : (
                    <div className='px-1'><CheckboxIcon size={16}/></div>
                )}
                <Pill
                    textColor={option?.color}
                    name={option?.title}
                    className="px-[6px] py-[2px] text-[10px] leading-[18px] font-medium max-w-[80%]"
                />
            </div>
        </>
    )
}

export default MenuItems
